import React from 'react'
import Rabi from './../../assets/img/rabi-pic.jpg';
import kharif from './../../assets/img/kharif-pic.jpg';
import { Link } from 'react-router-dom';

const FieldCrops = () => {
  return (
    <div className="container my-3">

    <div className="abouts">
        <h5>Field Crops</h5>
    </div>

    <div className="about-box p-4 rounded shadow-lg" style={{textAlign:'justify'}}>

        <div className="row mb-1 justify-content-between">
            
            <div className="col-lg-6 mb-4  text-center">

                <img src={Rabi} alt="Seed Production" className="img-fluid rounded shadow-sm" />
              <Link to={"/products/field-crops/rabi-crops"} style={{color:'green',textDecoration:'none'}} >  
              <h5 className='mt-2'>Rabi Season</h5>
                <p>Wheat, Gram, Lentil, Barley, Toria, Mustard etc.</p>
                </Link>
            </div>
            <div className="col-lg-6 mb-4  text-center">
                <img src={kharif} alt="Seed Production" className="img-fluid rounded shadow-sm" />
                <Link to={"/products/field-crops/kharif-crops"} style={{color:'green',textDecoration:'none'}}>  
                <h5 className='mt-2'>Kharif Season</h5>
                <p>Cotton, Guar, Bajra, Paddy, Arhar, Til, Moth, Moong, Urad, Maize etc.</p>
                </Link>
            </div>


            
        </div>

        </div>
    </div>
  )
}

export default FieldCrops
